import Handsontable from 'handsontable'
import router from '../../router'
import {calculateTotalWeightOfOrders} from "./Settings"


export function weightRenderer(instance, td, row, col, prop, value, cellProperties, skipLastRow) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    let orderDetailsArr = instance.getDataAtRowProp(row, 'orderDetailsArr')                                  //prop name 'orderDetailsArr'
    let totalWt = calculateTotalWeightOfOrders(orderDetailsArr)
    td.innerHTML = totalWt + ' / ' + value +
                    '<p>' + Math.abs(totalWt - value) + '</p>'
    td.children[0].style.color = (totalWt - value) > 0 ? 'green':'red'
    if(skipLastRow && value.toString().includes('NA')) td.innerHTML = value.slice(0, -2)
}

export function truckOrderNumRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    let truckOrderId = instance.getDataAtRowProp(row, 'truckOrderId')                                  //prop name 'truckOrderId'
    td.style.color = 'blue'
    td.classList.add('truck-order-num-txt')
    td.onclick = function() {
        router.push({ path: '/excel-truck-orders/'+truckOrderId})
    }
}
export function truckOrderStatusRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    let status = instance.getDataAtRowProp(row, 'internalstatus')                                  //prop name 'internalstatus'
    td.innerHTML = status
}
export function ewayBillRenderer(instance, td, row, col, prop, value, cellProperties, skipLastRow) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    if(!value){
        td.innerHTML = '<i class="fas fa-plus-circle" style="font-size: 22px"></i>'
    }else{
        td.innerHTML = value
    }
  if(skipLastRow && value === 'NA') td.innerHTML = ''
}

